import { Text, Box } from "@mantine/core";
import { motion, wrap } from "framer-motion";
import { ThemeType } from "../util/types";
import DynamicText from "./DynamicText";

type MultipleChoiceProps = {
  theme: ThemeType;
  round: string;
  instructions: string;
  cards: string[];
  reminder: string;
  totalPlayersSubmitted: number;
};

const MultipleChoice = ({
  theme,
  round,
  instructions,
  cards,
  reminder,
  totalPlayersSubmitted,
}: MultipleChoiceProps) => {
  const renderInstructions = () => {
    return (
      <>
        <DynamicText
          style={{
            color: theme.ButtonColor,
            fontSize: 15,
          }}
        >
          {round}
        </DynamicText>
        <Text
          style={{
            color: theme.TextColor,
            wrap,
            fontSize: 40,
          }}
        >
          {instructions}
        </Text>
      </>
    );
  };
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh)",
        textAlign: "center",
        alignItems: "center",
      }}
    >
      {renderInstructions()}
      <Box
        style={{
          justifyContent: "center",
          alignContent: "center",
          justifyItems: "center",
          alignItems: "center",
          flexWrap: "wrap",
          display: "flex",
          height: "100%",
        }}
      >
        {cards.map((c, i) => {
          return (
            <motion.div
              key={i + c + cards.length}
              initial={{ x: "calc(-250vw)" }}
              animate={{ x: 0 }}
              transition={{
                damping: 10,
                duration: 1.5,
                delay: (cards.length - i - 2) * 0.2,
              }}
            >
              <DynamicText
                style={{
                  border: "2px solid " + theme.TextColor,
                  borderRadius: 15,
                  width: "calc(25vw)",
                  height: "calc(10vw)",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  justifyItems: "center",
                  fontSize: 18,
                  margin: 5,
                }}
              >
                {" "}
                {c}
              </DynamicText>
            </motion.div>
          );
        })}
      </Box>
      <Box
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          height: "20%",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <motion.div
          key={totalPlayersSubmitted}
          animate={{ scale: [1.0, 1.2, 1.0] }}
          transition={{ duration: 0.3 }}
        >
          {totalPlayersSubmitted > 0 ? (
            <Box
              style={{
                margin: 10,
                padding: 10,
                width: 200,
                fontSize: "30px",
                border: "2px solid white",
                borderRadius: "15px",
                textAlign: "center",
                alignContent: "center",
              }}
            >
              {"Players In: " + totalPlayersSubmitted}
            </Box>
          ) : (
            <Box style={{ margin: 10, padding: 10, width: 200 }} />
          )}
        </motion.div>
        <motion.div
          animate={{ scale: [0.8, 1.2, 0.8] }}
          transition={{ repeat: Infinity, damping: 10, duration: 2.5 }}
        >
          <DynamicText
            style={{
              color: theme.ReminderColor,
              margin: 10,
              padding: 10,
              width: 400,
              fontSize: 25,
            }}
          >
            {reminder}
          </DynamicText>
        </motion.div>
        <Box style={{ width: 200, margin: 10, padding: 10 }} />
      </Box>
    </Box>
  );
};

export default MultipleChoice;
